const getDevices = (state) => state.entities.devices.byId;

export const getCurrentDeviceById = (state, deviceId) => getDevices(state)[deviceId];
